import { Layer, ObjectCategory } from "@common/constants";
import { type Vector } from "@common/utils/vector";
import { Game } from "../game";
import { type Building } from "../objects/building";

/**
 * A roof over `position` on the ground floor, of the buildings the page has: a building's, standing, a room's (not a
 * canopy's over a door: `noCeilingScopeEffect`). Under one, no rain or snow falls on the screen (war/warWeather.ts) and
 * no long dusk shadow falls (objects/playerGear.ts): 1.06.1's audit
 */
export function roofOver(position: Vector): boolean {
    for (const building of Game.objects.getCategory(ObjectCategory.Building)) {
        if (building.layer !== Layer.Ground) continue;
        if (building.dead && !building.definition.hasDamagedCeiling) continue;
        if (building.definition.noCeilingScopeEffect) continue;
        if (building.ceilingHitbox?.isPointInside(position)) return true;
    }
    return false;
}

/**
 * The roof's deck (1.08: `BuildingDefinition.openAir`) on `layer` under `position`, of the buildings the page has: one
 * standing there is out in the open, over the roofs under it (server/src/roofs.ts `deckAt` is the server's)
 */
export function deckAt(layer: Layer, position: Vector): Building | undefined {
    if (layer <= Layer.Ground) return undefined;
    for (const building of Game.objects.getCategory(ObjectCategory.Building)) {
        if (building.layer !== layer || building.deckFloor === undefined) continue;
        if (building.deckFloor.isPointInside(position)) return building;
    }
    return undefined;
}

/**
 * under a roof or the ground: on another floor than the ground's (but out on a roof's deck, 1.08), or under a roof on
 * it
 */
export const underCover = (layer: Layer, position: Vector): boolean =>
    layer === Layer.Ground ? roofOver(position) : deckAt(layer, position) === undefined;
